import React from 'react'

const IconClose = ({ color = '#bbbdbf', width = '1rem', height = '1rem' }) => (
  <svg
    role="img"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <mask
      id="mask0_3894_5878"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
      style={{ maskType: 'alpha' }}
    >
      <rect width="24" height="24" fill={color} />
    </mask>
    <g mask="url(#mask0_3894_5878)">
      <path
        d="M6.39911 18.3077L5.69141 17.6L11.2914 12L5.69141 6.39996L6.39911 5.69226L11.9991 11.2923L17.5991 5.69226L18.3068 6.39996L12.7068 12L18.3068 17.6L17.5991 18.3077L11.9991 12.7077L6.39911 18.3077Z"
        fill={color}
      />
    </g>
  </svg>
)

export default IconClose
